import { render, staticRenderFns } from "./BookedClasses.vue?vue&type=template&id=1350dc7f&scoped=true"
import script from "./BookedClasses.vue?vue&type=script&lang=js"
export * from "./BookedClasses.vue?vue&type=script&lang=js"
import style0 from "./BookedClasses.vue?vue&type=style&index=0&id=1350dc7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1350dc7f",
  null
  
)

export default component.exports